var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.162 14c-.296 0-.676-.096-1.15-.377l-1.67-.994c-.173-.102-.508-.102-.675 0l-1.675.994c-.988.59-1.569.354-1.831.163-.257-.19-.66-.68-.397-1.804l.397-1.725c.044-.18-.045-.49-.179-.624L2.597 8.239c-.692-.697-.636-1.293-.541-1.585s.396-.81 1.357-.973l1.78-.297a.8.8 0 0 0 .48-.36l.989-1.984C7.109 2.135 7.695 2 8.002 2s.893.135 1.34 1.04l.982 1.978c.079.152.319.332.486.36l1.781.298c.966.163 1.267.68 1.357.972.089.293.145.888-.542 1.585l-1.384 1.4c-.134.135-.218.438-.18.624l.397 1.725c.257 1.124-.14 1.613-.396 1.804-.14.102-.363.214-.681.214m-3.16-2.293c.273 0 .547.067.765.196l1.669.995c.486.293.793.293.91.208s.201-.382.078-.933l-.396-1.725c-.106-.467.067-1.068.402-1.411l1.384-1.394c.274-.275.397-.545.34-.73-.06-.186-.317-.338-.697-.4l-1.78-.298c-.43-.073-.9-.421-1.095-.815l-.983-1.978c-.178-.36-.402-.573-.597-.573-.196 0-.419.213-.592.573L6.422 5.4c-.196.394-.665.742-1.094.815l-1.776.298c-.38.062-.636.214-.698.4-.061.185.067.46.34.73L4.58 9.037c.335.337.508.944.402 1.41l-.396 1.726c-.128.557-.04.849.078.933s.419.079.91-.208l1.67-.995c.212-.129.485-.196.759-.196"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPassive);
export default __webpack_public_path__ + "static/media/starPassive.e6e53de04077b0834a4f4649837d1774.svg";
export { ForwardRef as ReactComponent };